













































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MaterialCard from '@/components/material/Card/index.vue';
import {
  IGetBookingDetailResponse,
  ILockBookingRequest,
  lockBooking,
  IUnlockBookingRequest,
  unlockBooking,
} from '@/api/booking';
import { formatApiError } from '@/utils/index';
import { getParticipantName } from '@/utils/tickets';
import { AppModule } from '@/store/modules/app';
import {
  IssuingRule,
  IssuingRuleId,
  BookingDetailLockActionEnum,
  BookingStatusEnum,
} from '@/api/types';
import BookingDetailTickets from './Tickets.vue';

@Component({
  name: 'BookingDetailInfo',
  components: {
    MaterialCard,
  },
})
export default class extends Vue {
  @Prop({ required: true }) data!: IGetBookingDetailResponse;
  private isEditingLock = false;
  private lockSwitch = false;

  get bookingId() {
    return this.data.booking.bookingId;
  }

  get showBookingStatus() {
    return (
      (this.data.bookingStatus as BookingStatusEnum) !==
      BookingStatusEnum.CONFIRMED
    );
  }

  get participantName() {
    return getParticipantName(
      this.data.booking.participantFirstName as string,
      this.data.booking.participantLastName as string,
      AppModule.language
    );
  }

  get participantDate() {
    if (this.data.booking.targetDate) {
      const date = this.data.booking.targetDate;
      return `${date.year}-${date.month}-${date.day}`;
    } else {
      return '';
    }
  }

  get productName() {
    return `${this.data.booking.activityTitle} | ${this.data.booking.planTitle}`;
  }

  get planStartTime() {
    return this.data.booking.planStartTime;
  }

  get agentName() {
    return this.data.booking.agentName;
  }

  get showCannotPartiallyIssue() {
    return this.cannotPartiallyIssue;
  }

  get cannotPartiallyIssue() {
    if (
      this.data.issuingRules &&
      this.data.issuingRules.some(
        r => (r.id as IssuingRuleId) === IssuingRuleId.CANNOT_PARTIALY_ISSUE
      )
    ) {
      return true;
    }
    return false;
  }

  get locked() {
    return this.data.lock && !!this.data.lock.isActive ? true : false;
  }

  get canEditLock() {
    if (this.locked) {
      return (
        this.data.lock &&
        (!this.data.lock.forbiddenActions ||
          this.data.lock.forbiddenActions.every(
            a =>
              (a as BookingDetailLockActionEnum) !==
              BookingDetailLockActionEnum.UNLOCK
          ))
      );
    } else {
      return (
        !this.data.lock ||
        !this.data.lock.forbiddenActions ||
        this.data.lock.forbiddenActions.every(
          a =>
            (a as BookingDetailLockActionEnum) !==
            BookingDetailLockActionEnum.LOCK
        )
      );
    }
  }

  get lockedBy() {
    if (
      this.data.lock &&
      this.data.lock.isActive &&
      this.data.lock.accountName
    ) {
      return this.data.lock.accountName;
    }
    return '';
  }

  get lockedAt() {
    if (this.data.lock && this.data.lock.isActive && this.data.lock.updatedAt) {
      return new Date(this.data.lock.updatedAt).toLocaleString();
    }
    return '';
  }

  private handleEditingLockButtonClick() {
    this.isEditingLock = !this.isEditingLock;
    this.lockSwitch = this.locked ? true : false;
  }

  private async handleLock() {
    if (this.locked === this.lockSwitch) {
      this.isEditingLock = false;
      return;
    }

    AppModule.ShowOverlay();
    try {
      if (this.lockSwitch) {
        const req = {
          bookingId: this.data.booking.bookingId,
          bookingRecordVersion: this.data.version,
        } as ILockBookingRequest;
        await lockBooking(req);
      } else {
        const req = {
          bookingId: this.data.booking.bookingId,
        } as IUnlockBookingRequest;
        await unlockBooking(req);
      }
      this.$toast.success(
        this.$t(this.lockSwitch ? 'Locked' : 'Unlocked') as string,
        {
          icon: 'mdi-lock',
        }
      );
      this.$emit(BookingDetailTickets.ticketsUpdatedEvent);
      AppModule.HideOverlay();
    } catch (err) {
      AppModule.HideOverlay();
      this.$toast.error(
        this.$t('Failed to {do} due to {err}', {
          do: (this.$t(
            this.lockSwitch ? 'Lock' : 'Unlock'
          ) as string).toLowerCase(),
          err: formatApiError(this.$i18n, err),
        }) as string,
        {
          icon: 'mdi-alert',
        }
      );
    }
    this.isEditingLock = false;
  }
}
